import { render, staticRenderFns } from "./Timeline4.vue?vue&type=template&id=ddd6d9a4&"
import script from "./Timeline4.vue?vue&type=script&lang=js&"
export * from "./Timeline4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports